import { Controller } from "@hotwired/stimulus"

// Drives the per-member "assign to tenant" dialog: closes on backdrop/Escape and
// narrows the role dropdown to the roles of the currently selected tenant (each
// role <option> carries data-tenant-id; the blank "default role" option is always
// shown). Opening is handled by the shared dialog-opener controller.
export default class extends Controller {
  static targets = ["tenantSelect", "roleSelect"]

  connect() {
    this.filterRoles()
  }

  close() {
    this.element.close()
  }

  backdropClick(event) {
    if (event.target === this.element) this.close()
  }

  onClose() {
    document.body.style.overflow = ""
  }

  filterRoles() {
    if (!this.hasTenantSelectTarget || !this.hasRoleSelectTarget) return

    const tenantId = this.tenantSelectTarget.value
    let selectionStillVisible = false

    for (const option of this.roleSelectTarget.options) {
      const optionTenant = option.dataset.tenantId
      const visible = !optionTenant || optionTenant === tenantId
      // SlimSelect reads an option as hidden from `hidden` or `style.display`, and
      // rebuilds the native options with only `hidden` — drive that one.
      option.hidden = !visible
      option.disabled = !visible
      if (visible && option.selected) selectionStillVisible = true
    }

    if (!selectionStillVisible) this.roleSelectTarget.value = ""

    // The role select is wrapped by the `select` controller (SlimSelect); re-sync
    // it so the newly hidden/shown options are reflected in the searchable list.
    const ctrl = this.application.getControllerForElementAndIdentifier(
      this.roleSelectTarget,
      "select",
    )
    if (ctrl) ctrl.refresh()
  }

  disconnect() {
    document.body.style.overflow = ""
  }
}
